import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { Order, OrderStatus } from '../../../models';
import { OrderInfo } from './order/OrderInfo';
import { RepurchaseItems } from './RepurchaseItems';

const useStyles = makeStyles(({
  groupTitle: {
    fontFamily: "'Inter Tight', sans-serif",
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: '-.01em',
    color: '#16141D',
    margin: '0 0 15px',
  },
}));

export const PreviousOrderHistory = (
  { previousOrders }: { previousOrders: Order[] },
) => {
  const classes = useStyles();

  const renderOrderDetails = () => previousOrders.map(order => (
    <OrderInfo
      key={`previous-order-${order.id}`}
      order={order}
      actionItems={order.status === OrderStatus.CANCEL
        ? <RepurchaseItems order={order} />
        : undefined}
    />
  ));

  return (
    <Box
      id="previous-order-container"
      display="flex"
      flexDirection="column"
      paddingTop={2}
      paddingBottom={2}
    >
      <Box id="previous-order-title">
        <Typography className={classes.groupTitle}>
          <FormattedMessage id="page.order.history.previous.order.title" />
        </Typography>
      </Box>
      {renderOrderDetails()}
    </Box>
  );
};
